let config = ($mdDateLocaleProvider) => {
	$mdDateLocaleProvider.formatDate = function(date) {
	   return moment(date).format('DD/MM/YYYY');
	};

	$mdDateLocaleProvider.months = [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro'
	];

	$mdDateLocaleProvider.shortMonths = [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Sep',
		'Out',
		'Nov',
		'Dez'
	];

	$mdDateLocaleProvider.days = [
		'Domingo',
		'Segunda-feria',
		'Terça-feria',
		'Quart-feria',
		'Quinta-feria',
		'Sexta-feira',
		'Sábado'
	];

	$mdDateLocaleProvider.shortDays = [ 
		'Dom',
		'Seg',
		'Ter',
		'Qua',
		'Qui',
		'Sex',
		'Sáb'
	];

	$mdDateLocaleProvider.firstDayOfWeek = 1;

	$mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	  return 'Semana ' + weekNumber;
	};
	
	$mdDateLocaleProvider.msgCalendar = 'Calendário';
	$mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendário';
}

config.$inject = ['$mdDateLocaleProvider'];

export default config;


// WEBPACK FOOTER //
// ./client/app/config/md-date-locale-provider-config.js